<template>
  <div>
    <el-row style="margin: 0 auto;">
      <el-col :span="22">
        <el-form ref="searchForm" :model="searchForm" style="display: flex;column-gap: 20px;">
          <el-form-item>
            <div>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                size="mini"
                class="w300"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>  
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('1')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">全市场销售额(新单+补单)</div>

            <div id="main1" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">全市场总成交人数(老客+新客)</div>

            <div id="main2" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">市场的本金、赠金、店均值的数据比例</div>
            <div id="main3" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">收款本金、赠金、赠金比例分析</div>
            <div id="main4" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
      <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">市场新单业绩和补单业绩数据分析</div>
            <div id="main5" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">市场护理手工数据分析</div>
            <div id="main6" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">各市场业绩表</div>
            <el-table
              :data="shopTableData"
              border
              size="small"
              :default-sort = "{prop: 'receipts', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="门店" width="120"/>
              <el-table-column prop="receipts" label="收款本金" sortable />
              <el-table-column prop="receipts_gift" label="收款赠金" sortable />
              <el-table-column prop="contribution_rete" label="市场贡献度" sortable>
                <template slot-scope="{row}"> 
                  {{row.contribution_rete}}%
                </template>    
              </el-table-column>             
              <el-table-column prop="xd_perform" label="新单业绩"  sortable/>
              <el-table-column prop="bd_perform" label="补单业绩"  sortable/>
              <el-table-column prop="consume_amount" label="消耗金额" sortable/>
              <el-table-column prop="amount_care_num" label="护理人数" width="140" sortable/>
              <el-table-column prop="num_care" label="护理量" width="140" sortable/>
              <el-table-column prop="consume_avg" label="单次护理金额（本金）" width="200" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom:3%;">市场服务销售表</div>
            <el-table
              :data="serviceList"
              height="600"
              size="small"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="150"/>
              <el-table-column prop="pay_amount" label="销售本金" align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金" align="center" sortable />
              <el-table-column prop="num" label="销售数量" width="120" align="center" sortable />
              <el-table-column prop="cj_num" label="成交人数"  width="120" align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">市场商品销售表</div>
            <el-table
              :data="goodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              >
              <el-table-column prop="name" label="产品名称" width="150"/>
              <el-table-column prop="pay_amount" label="销售本金"  align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金"  align="center"  sortable />
              <el-table-column prop="num" label="销售数量"  width="120" align="center"  sortable/>
              <el-table-column prop="cj_num" label="成交人数" width="120"  align="center" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { goodsTop,serviceTop,getLookShop,getPersonChannel   } from '@/api/sys'
import { mapGetters } from "vuex";
class Search {
  date = ['2025-08-01','2025-08-30'];
  shop_id = 73782774707242;

}

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
  },
    watch: {
    // 监听 tabIndex 变化，触发刷新
    tabIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList(); // 调用数据加载方法
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const currentYear = new Date().getFullYear();
          const juneFirst = new Date(currentYear, 5, 1);
          juneFirst.setHours(0, 0, 0, 0);
          return time.getTime() < juneFirst.getTime();
        }
      },
      searchForm: new Search(),
      name:'郑州市场',
      cjNum:0,
      cjAmount:0,
      shopList:[],
      qList1:[],
      qList2:[],
      newList:[],
      allList:[],
      goodsList:[],
      serviceList:[],
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      list:[],
      shopTableData:[],
      bodyTableData:[],
      hlNum:0,
      skAmount:0,
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
      this.getList();
      window.addEventListener('resize', this.handleResize);
    });
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart1) this.chart1.dispose();
    if (this.chart2) this.chart2.dispose();
    if (this.chart3) this.chart3.dispose();
    if (this.chart4) this.chart4.dispose();
    if (this.chart5) this.chart5.dispose();
    if (this.chart6) this.chart6.dispose();
  },
  
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.maxnum,
          colspan: 1
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    // 初始化图表实例
    initCharts() {
      const main1Dom = document.getElementById('main1');
      const main2Dom = document.getElementById('main2');
      const main3Dom = document.getElementById('main3');
      const main4Dom = document.getElementById('main4');
      const main5Dom = document.getElementById('main5');
      const main6Dom = document.getElementById('main6');

      
      if (main1Dom) this.chart1 = echarts.init(main1Dom);
      if (main2Dom) this.chart2 = echarts.init(main2Dom);
      if (main3Dom) this.chart3 = echarts.init(main3Dom);
      if (main4Dom) this.chart4 = echarts.init(main4Dom);
      if (main5Dom) this.chart5 = echarts.init(main5Dom);
      if (main6Dom) this.chart6 = echarts.init(main6Dom);


    },
    
    // 统一处理resize
    handleResize() {
      if (this.chart1) this.chart1.resize();
      if (this.chart2) this.chart2.resize();
      if (this.chart3) this.chart3.resize();
      if (this.chart4) this.chart4.resize();
      if (this.chart5) this.chart5.resize();
      if (this.chart6) this.chart6.resize();

    },
    
    getList() {

      if(this.userInfo.shop_id){
        this.searchForm.shop_id = this.userInfo.shop_id;
      }else{
        this.searchForm.shop_id = this.searchForm.shop_id;

      }

       const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });

      const requestPromises = [
        getLookShop().then(res => {
          this.shopList = res.data;
        }),
        goodsTop({
          start_time: this.searchForm.date[0],
          end_time: this.searchForm.date[1],
          shop_id: this.searchForm.shop_id 
        }).then(res => {
          this.goodsList = res.data;
        }),
        serviceTop({
          start_time: this.searchForm.date[0],
          end_time: this.searchForm.date[1],
          shop_id: this.searchForm.shop_id 
        }).then(res => {
          this.serviceList = res.data;
        }),
        getPersonChannel({
          start_time:this.searchForm.date[0],
          end_time:this.searchForm.date[1],
          shop_id:this.searchForm.shop_id 
        }).then(res =>{
          this.list = res.data
          this.shopTableData = [
                {
                    "id": 130,
                    "name": "门诊",
                    "shop_id": 73782774707242,
                    "receipts_gift": 1500,
                    "receipts": 36213,
                    "contribution_rete": 29,
                    "xd_perform": 2457,
                    "bd_perform": 33756,
                    "consume_amount": 28637.54,
                    "amount_care_num": 49,
                    "num_care": 218,
                    "consume_avg": 131.36
                },
                {
                    "id": 139,
                    "name": "东北",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 21015.44,
                    "contribution_rete": 17,
                    "xd_perform": 19525.44,
                    "bd_perform": 1490,
                    "consume_amount": 1658.44,
                    "amount_care_num": 8,
                    "num_care": 16,
                    "consume_avg": 103.65
                },
                {
                    "id": 429,
                    "name": "郑州",
                    "shop_id": 73782774707242,
                    "receipts_gift": 1500,
                    "receipts": 43365,
                    "contribution_rete": 35,
                    "xd_perform": 7070,
                    "bd_perform": 36295,
                    "consume_amount": 21190.52,
                    "amount_care_num": 38,
                    "num_care": 110,
                    "consume_avg": 192.64
                },
                {
                    "id": 575,
                    "name": "重庆",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 0,
                    "amount_care_num": 0,
                    "num_care": 0,
                    "consume_avg": 0
                },
                {
                    "id": 802,
                    "name": "济南",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 21238,
                    "contribution_rete": 17,
                    "xd_perform": 0,
                    "bd_perform": 21238,
                    "consume_amount": 25601.81,
                    "amount_care_num": 35,
                    "num_care": 146,
                    "consume_avg": 175.35
                },
                {
                    "id": 1021,
                    "name": "天津",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 498,
                    "amount_care_num": 1,
                    "num_care": 2,
                    "consume_avg": 249
                },
                {
                    "id": 1082,
                    "name": "西安",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 1653.04,
                    "amount_care_num": 1,
                    "num_care": 4,
                    "consume_avg": 413.26
                },
                {
                    "id": 1301,
                    "name": "昆明",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 1836.27,
                    "amount_care_num": 10,
                    "num_care": 14,
                    "consume_avg": 131.16
                },
                {
                    "id": 1387,
                    "name": "太原",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 4606.71,
                    "amount_care_num": 32,
                    "num_care": 56,
                    "consume_avg": 82.26
                },
                {
                    "id": 0,
                    "name": "合计",
                    "receipts_gift": 3000,
                    "contribution_rete": 100,
                    "receipts": 121831.44,
                    "xd_perform": 29052.44,
                    "bd_perform": 92779,
                    "consume_amount": 85682.33,
                    "amount_care_num": 174,
                    "num_care": 566,
                    "consume_avg": 151.38
                }
            ]

          this.bodyTableData = [
                {
                    "id": 130,
                    "name": "宁翠联",
                    "shop_name": "铜锣湾",
                    "shop_id": 73782774707242,
                    "receipts_gift": 1500,
                    "receipts": 36213,
                    "contribution_rete": 29,
                    "xd_perform": 2457,
                    "bd_perform": 33756,
                    "consume_amount": 28637.54,
                    "amount_care_num": 49,
                    "num_care": 218,
                    "consume_avg": 131.36
                },
                {
                    "id": 139,
                    "name": "高霞",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 21015.44,
                    "contribution_rete": 17,
                    "xd_perform": 19525.44,
                    "bd_perform": 1490,
                    "consume_amount": 1658.44,
                    "amount_care_num": 8,
                    "num_care": 16,
                    "consume_avg": 103.65
                },
                {
                    "id": 429,
                    "name": "祁慧萍",
                    "shop_name": "铜锣湾",
                    "shop_id": 73782774707242,
                    "receipts_gift": 1500,
                    "receipts": 43365,
                    "contribution_rete": 35,
                    "xd_perform": 7070,
                    "bd_perform": 36295,
                    "consume_amount": 21190.52,
                    "amount_care_num": 38,
                    "num_care": 110,
                    "consume_avg": 192.64
                },
                {
                    "id": 575,
                    "name": "杨璐珊",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 0,
                    "amount_care_num": 0,
                    "num_care": 0,
                    "consume_avg": 0
                },
                {
                    "id": 802,
                    "name": "任志欢",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 21238,
                    "contribution_rete": 17,
                    "xd_perform": 0,
                    "bd_perform": 21238,
                    "consume_amount": 25601.81,
                    "amount_care_num": 35,
                    "num_care": 146,
                    "consume_avg": 175.35
                },
                {
                    "id": 1021,
                    "name": "候玉敏",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 498,
                    "amount_care_num": 1,
                    "num_care": 2,
                    "consume_avg": 249
                },
                {
                    "id": 1082,
                    "name": "虚拟员工核销专用",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 1653.04,
                    "amount_care_num": 1,
                    "num_care": 4,
                    "consume_avg": 413.26
                },
                {
                    "id": 1301,
                    "name": "张小彩",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 1836.27,
                    "amount_care_num": 10,
                    "num_care": 14,
                    "consume_avg": 131.16
                },
                {
                    "id": 1387,
                    "name": "郭倩倩",
                    "shop_name": "云路街",
                    "shop_id": 73782774707242,
                    "receipts_gift": 0,
                    "receipts": 0,
                    "contribution_rete": 0,
                    "xd_perform": 0,
                    "bd_perform": 0,
                    "consume_amount": 4606.71,
                    "amount_care_num": 32,
                    "num_care": 56,
                    "consume_avg": 82.26
                },
                {
                    "id": 0,
                    "name": "合计",
                    "receipts_gift": 3000,
                    "contribution_rete": 100,
                    "receipts": 121831.44,
                    "xd_perform": 29052.44,
                    "bd_perform": 92779,
                    "consume_amount": 85682.33,
                    "amount_care_num": 174,
                    "num_care": 566,
                    "consume_avg": 151.38
                }
            ]
          this.cjAmount = this.shopTableData[this.shopTableData.length - 1].consume_amount;
          this.cjNum = this.shopTableData[this.shopTableData.length - 1].amount_care_num;
          this.echarts1(this.shopTableData.slice(0, -1));      

        }),
      ];

      Promise.all(requestPromises)
      .finally(() => {
        loading.close();
        this.$nextTick(() => {
          this.handleResize();
        });
      })
      .catch(err => {
        console.error("接口请求出错：", err);
        this.$message.error("数据加载失败，请重试");
      });
    },
    echarts1(jine) {
      if (!this.chart1) return;
      if (!this.chart2) return;
      if (!this.chart3) return;
      if (!this.chart4) return;
      if (!this.chart5) return;
      if (!this.chart6) return;


      const option7 = {
        title: {
          show:false,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理师贡献度') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: [ '收款本金','收款赠金','店均值'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为右侧Y轴腾出更多空间
          bottom: '1%', // 增加底部空间防止标签截断
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name:'收款本金',
            type: 'bar',
            data: jine.map(item => item.receipts),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}%' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '店均值',
            type: 'line',
            data: jine.map(item => item.consume_amount),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: '#78DF69',
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          },
          {
            name: '收款赠金',
            type: 'bar',
            data: jine.map(item => item.consume_amount),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号       
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          }
        ]
      };

      const option4 ={
        title: {
          show:false,
          text: `${this.name}护理师收款本金与赠金分析`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('赠送比例') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: [ '收款本金','收款赠金','赠送比例'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为右侧Y轴腾出更多空间
          bottom: '1%', // 增加底部空间防止标签截断
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLine: { 
              lineStyle: { 
                color: 'red' 
              } 
            },
            axisLabel: {  
              formatter: '{value}元',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              lineStyle: { 
                color: '#CDD3E2' 
              } 
            }
          },
          {
            type: 'value',
            name: '比例',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            axisLine: { 
              show: true, // 显示第二条Y轴线以便观察
              lineStyle: {
                color: 'none' // 与贡献度颜色呼应
              }
            },
            axisLabel: {  
              formatter: '{value}%',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              show: false 
            },
          }
        ],
        series: [
          {
            name: '收款本金',
            type: 'bar',
            yAxisIndex: 0, // 关键修复：指定使用第二个Y轴
            data: jine.map(item => item.receipts),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' 
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '收款赠金',
            type: 'bar',
            yAxisIndex: 0, 
            data: jine.map(item => item.receipts_gift),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',      
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '赠送比例',
            type: 'line',
            yAxisIndex: 1, 
            data: jine.map(item => {
              const gift = Number(item.receipts_gift) || 0; // 转换为数值，默认0
              const total = Number(item.receipts) || 0;
              return total === 0 ? 0 : Number(((gift / total) * 100).toFixed(2));
            }),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: '#78DF69',
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}%' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '%';
              }
            }
          }
        ]
      };
      const option5 = {
        title: {
          show:false,
          text: `市场新单补单业绩`,
          left: 'center',
          textStyle: { 
            fontSize: 24

          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '0%',
          data: ['新单业绩', '补单业绩'],
          textStyle: {  }
        },
        grid: {
          left: '5%',
          right: '5%', // 为图例腾出空间
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: { } },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '新单业绩',
            type: 'bar',
            data: jine.map(item => item.xd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          },
          {
            name: '补单业绩',
            type: 'bar',
            data: jine.map(item => item.bd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          }
        ]
      };
      const option6 = {
        title: {
          show:false,
          text: `${this.name}护理师护理量/人头数/护理金额分析`,
          left: 'center',
          textStyle: {
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['护理人数', '护理量', '单次护理金额（本金）'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%', // 增加底部空间，避免滑动条遮挡
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { 
           rotate: 45, interval: 0,color: '#000',fontSize: 12
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLine: { 
              lineStyle: { 
                color: '#3468E9'
              } 
            },
            axisLabel: {  
              formatter: '{value}',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              lineStyle: { 
                color: '#CDD3E2' 
              } 
            }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            axisLine: { 
              show: false
            },
            axisLabel: {  
              formatter: '{value}元',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              show: false 
            }
          }
        ],
        series: [
          {
            name: '护理人数',
            type: 'bar',
            data: jine.map(item => item.amount_care_num),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}人'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '护理量',
            type: 'bar',
            data: jine.map(item => item.num_care),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}次'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '次';
              }
            }
          },
          {
            name: '单次护理金额（本金）',
            type: 'bar',
            data: jine.map(item => item.consume_avg),
            barWidth: '20%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          }
        ]
      };


      const baseColors = [
          '#2767FC', '#3491FA', '#4DA6FF', '#69B1FF', // 蓝色系（浅→深）
          '#E49119', '#F3C669', '#FFD787', '#FFE8B3', // 橙色系
          '#36CFC9', '#5AD8A6', '#8AE29E', '#B7F0B3', // 绿色系
          '#D93F30', '#F56C6C', '#FF9E99', '#FFC7C2', // 红色系
          '#722ED1', '#9370DB', '#B39DDB', '#D8C9F0', // 紫色系
          '#86909C', '#A8B0BD', '#C9CDD4', '#E5E6EB'  // 灰色系
      ];

     const option1 = {
        color: baseColors,
        title: {
          text: this.cjAmount,
          textStyle: {
            fontSize: 32,
            color: '#2767FC',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}元 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: jine.filter(item => item.proceeds_balance !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false // 图例隐藏，不影响核心功能
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: function(params) {
                // 双重保险：即使有漏网的0值，也隐藏标签
                if (params.value === 0) {
                  return '';
                }
                return `${params.name}: ${params.value}元 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            // 关键：过滤掉proceeds_balance为0的数据，不渲染对应的扇区
            data: jine
              .filter(item => item.consume_amount !== 0) // 只保留非0值数据
              .map(item => ({
                name: item.name,
                value: item.consume_amount
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
     const option2 = {
        color: baseColors,
        title: {
          text: this.cjNum,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC', 
            fontWeight: 'bold' 
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          // 双重保险：0值不显示tooltip
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}人 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          // 图例同步过滤0值（当前隐藏，后续开启时保持与饼图数据一致）
          data: jine.filter(item => item.cjCount !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              // 双重保险：0值不显示标签（过滤后理论无0值，防意外）
              formatter: function(params) {
                if (params.value === 0) {
                  return '';
                }
                return `${params.name}: ${params.value}人 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            // 关键：过滤掉cjCount为0的数据，不渲染对应扇区
            data: jine.filter(item => item.amount_care_num !== 0).map(item => ({
                name: item.name,
                value: item.amount_care_num // 人数数据（确保字段正确）
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
     

      this.chart1.setOption(option1);
      this.chart2.setOption(option2);
      this.chart3.setOption(option7);
      this.chart4.setOption(option4);
      this.chart5.setOption(option5);
      this.chart6.setOption(option6);
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex%2 == 0) {
        return 'ou-row';

      } else{
        return 'ji-row';

      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table tr.ou-row {
  background-color: #EEF6FF;
}
::v-deep .el-table tr.ji-row {
  background-color: #D4E6F4;
}

 ::v-deep .el-table__cell {
  //  background: #EEF6FF !important;
   color: #2861C0 !important;
   color: #333333 !important;
   color: #2861C0 !important;

   font-weight: 600;
   font-size: 15px;
 }
  // ::v-deep .el-table__body {
  //   td:nth-child(1) { // 第2列
  //     color: #000000 !important;
  //   }
  // }

::v-deep .el-table__header .el-table__cell {
  background: #C2DBF9  !important; /* 与内容区背景统一 */
  color: #000000 !important;
}

::v-deep .el-table__row:hover > .el-table__cell {
  // background: #C2DBF9  !important; /* 略浅的hover背景，保持一致性 */
}
.flex{
  color: #333;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    font-size: 1.2rem;
    padding: 1.5rem 3rem;
    border: 1px solid #EDF2FF;
    border-radius: 0.5rem;
    box-shadow: inset 0 0 0.5rem #EDF2FF;
    background-color: #EDF2FF;
    overflow: hidden;
    text-align: center;
    span{
      display: block; 
      font-size: 2.5rem;
      line-height: 3rem;
      margin-bottom: 0.3rem;
    }
  }
}
/* 图表容器样式优化 */
.charts-container {
  margin: 20px 0;
 text-align: center;
  .table-title{
    display: inline-block; 
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    background: #79A7FE;
    // background: #C2DBF9;
  //  background: linear-gradient(270deg, #33bea7 0%, #60e0c5 50%, #88f0e1 100%);
    padding:1rem ;
    border-radius: 1rem;

  }
}

.chart-wrapper {
  width: 100%;
  box-sizing: border-box; /* 确保padding不会增加元素总宽度 */
  background: #EDF2FF;
  padding: 2%;
  box-sizing: border-box;
  border-radius: 3rem;

}

.chart-content {
  width: 100%;
  height: 540px; /* 固定高度，确保初始化时有明确尺寸 */
}
</style>
